import { Projection, schema, types } from 'papr'

const VALID_SOURCES = ['blogs' as const, 'discussions' as const]

export const replySchema = schema(
	{
		content: types.string({ required: true }),
		contentMarkdown: types.string({ required: true }),
		author: types.objectId({ required: true }),
		dateAdded: types.date({ required: true }),
		isActive: types.boolean(),
		stamp: types.string(),
		upvotes: types.number(),
		reactions: types.array(types.objectId()),
		source: types.enum(VALID_SOURCES),
		reactionToCountMap: types.object({}),
		totalReactions: types.number(),
		isCollapsed: types.boolean(),
	},
	{
		defaults: {
			isActive: true,
			isCollapsed: false,
		},
	},
)

export const responseSchema = schema(
	{
		contentMarkdown: types.string({ required: true }),
		content: types.string({ required: true }),
		author: types.objectId({ required: true }),
		post: types.objectId({ required: true }),
		draft: types.objectId(),
		replies: types.array(replySchema[0]),
		popularity: types.number(),
		dateAdded: types.date({ required: true }),
		isActive: types.boolean(),
		stamp: types.string(),
		source: types.enum(VALID_SOURCES),
		upvotedBy: types.array(types.objectId()),
		downvotedBy: types.array(types.objectId()),
		upvotes: types.number(),
		downvotes: types.number(),
		isCollapsed: types.boolean(),
		collapsedBy: types.array(types.objectId()),
		badgesAwarded: types.array(
			types.object({
				badge: types.objectId(),
				from: types.array(types.objectId()),
			}),
		),

		totalBadgesAwarded: types.number(),
		isRewardWinner: types.boolean(),
		downvotedByCurrentUser: types.boolean(),
		bookmarkedIn: types.array(types.string()),
		score: types.number(),
		reactions: types.array(types.objectId()),
		reactionToCountMap: types.object({}),
		totalReactions: types.number(),
	},
	{
		defaults: {
			isActive: true,
			isCollapsed: false,
		},
	},
)

export type ResponseDocument = (typeof responseSchema)[0]
export type ResponseSchemaOptions = (typeof responseSchema)[1]
export type ResponseProjection = Projection<ResponseDocument>

export type ReplyDocument = (typeof replySchema)[0]
export type ReplyProjection = Projection<ReplyDocument>
